<template lang="pug">
v-app.app(light)
  v-flex.progress(v-if='requests')
    v-progress-linear(:indeterminate='true', :height='3', color='white')
  v-navigation-drawer(v-model='drawer', clipped, fixed, app)
    s-drawer-menu(:items='userMenu', @click='navigate')
  v-toolbar.toolbar(
    color='primary',
    app,
    fixed,
    clipped-left,
    prominent,
    flat,
    dark
  )
    v-toolbar-side-icon(@click.stop='drawer = !drawer')
    v-toolbar-title.with-pointer(@click='$router.push({ name: "Index" })')
      template(v-if='$vuetify.breakpoint.name === "xs"')
        | {{ $config.appShortName }}
      template(v-else) {{ $config.appLongName }}
    v-spacer
    template(
      v-if=`
        $user.hasRoles([userRoles.Client, userRoles.Manager]) &&
        $vuetify.breakpoint.name !== "xs"
      `
    )
      .mr-3.font-weight-medium {{ user.name }}
    template(v-if='$user.hasRoles([userRoles.Admin])')
      s-search-bar.mr-3(v-if='searchOpened', @blur='closeSearch')
      v-btn(v-else, @click='openSearch', icon)
        v-icon search
    v-menu(absolute, light, left)
      v-btn(icon, slot='activator')
        v-icon more_vert
      v-list
        v-list-tile(@click='logout')
          v-list-tile-action
            v-icon exit_to_app
          v-list-tile-content
            v-list-tile-title Выход
  v-content
    v-container(fluid, fill-height)
      v-layout
        v-flex
          s-slide-fade
            router-view(:class='["main-view", { wide }]')
  s-snack
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { userRoles } from '@/enums/user-roles'

export default {
  data: () => ({
    userRoles,
    drawer: false,
    searchOpened: false,
    menu: [
      {
        action: 'settings',
        title: 'Мой профиль',
        active: true,
        routeGroup: 'Profile',
        items: [
          { title: 'Изменить профиль', route: 'Profile.Edit' },
          { title: 'Смена пароля', route: 'Profile.ChangePassword' },
        ],
      },
      {
        action: 'face',
        title: 'Мой кабинет',
        routeGroup: 'Client',
        items: [
          { title: 'Договора', route: 'Client.Deals' },
          { title: 'Запись на осмотр', route: 'Client.ScheduleAssign' },
        ],
      },
      {
        action: 'supervisor_account',
        title: 'Я партнер',
        routeGroup: 'Partner',
        items: [
          { title: 'Мои организации', route: 'Partner.Organizations' },
          { title: 'График ввода', route: 'Partner.BuldingSchedule' },
        ],
      },
      {
        action: 'security',
        title: 'Администрирование',
        routeGroup: 'Admin',
        items: [
          { title: 'Пользователи', route: 'Admin.Users' },
          { title: 'Менеджеры', route: 'Admin.Managers' },
          { title: 'Офисы', route: 'Admin.Offices' },
          { title: 'Упр. компании', route: 'Admin.ManCompanies' },
          { title: 'Онлайн–камеры', route: 'Admin.Cameras.List' },
          { title: 'Сайты', route: 'Content.Sites' },
          { title: 'Скрипты на сайт', route: 'Content.Scripts' },
        ],
      },
      {
        action: 'supervisor_account',
        title: 'Партнеры',
        routeGroup: 'Partners',
        items: [
          { title: 'Организации', route: 'Partners.Organizations' },
          { title: 'Акции', route: 'Partners.Actions' },
        ],
      },
      {
        action: 'business',
        title: 'Обьекты',
        routeGroup: 'Objects',
        items: [
          { title: 'Комплексы', route: 'Complexes' },
          { title: 'Типовые планировки', route: 'Complexes.Layouts' },
          // {
          //   title: 'Преимущества',
          //   route: 'Complexes.Advantages.List',
          //   available: 'advantages_assign',
          // },
        ],
      },
      {
        action: 'recent_actors',
        title: 'Работа',
        routeGroup: 'Job',
        items: [
          { title: 'Вакансии', route: 'Job.Vacancies' },
          { title: 'Истории успеха', route: 'Job.Stories' },
        ],
      },
      {
        action: 'done_all',
        title: 'Чеклисты',
        routeGroup: 'Checklist',
        items: [{ title: 'Отчеты', route: 'Checklist.Report' }],
      },
      {
        action: 'source',
        title: 'Контент',
        routeGroup: 'Content',
        items: [
          {
            title: 'Новости',
            route: 'Content.News.List',
          },
          {
            title: 'Акции',
            route: 'Content.Actions.List',
          },
          {
            title: 'Баннеры',
            route: 'Content.Banners.List',
          },
          {
            title: 'Соцсети-медиа',
            route: 'Content.SocialGallery.List',
          },
          {
            title: 'Контент страниц',
            route: 'Content.SiteTree.List',
          },
          {
            title: 'Галерея',
            route: 'Content.Gallery.List',
          },
          {
            title: 'Инфраструктура',
            route: 'Content.Infrastructure.Edit',
          },
        ],
      },
      {
        action: 'assignment',
        title: 'Справочники',
        routeGroup: 'Dictionaries',
        items: [
          {
            title: 'Иконки меток',
            route: 'InfrastructureDictionary.List',
          },
          {
            title: 'Преимущества квартир',
            route: 'Advantages.List',
          },
        ],
      },
      {
        action: 'shopify',
        title: 'Магазин',
        routeGroup: 'Shop',
        items: [
          { title: 'Все товары', route: 'Shop.Goods', available: 'goods_edit' },
          {
            title: 'Категории',
            route: 'Shop.Categories',
            available: 'goods_category_edit',
          },
          // { title: 'Склад', route: 'Shop.Goods', available: 'goods_remains' },
          { title: 'Заказы', route: 'Shop.Orders', available: 'goods_orders' }
        ],
      },
      {
        action: 'travel_explore',
        title: 'SEO',
        routeGroup: 'Seo',
        items: [
          { title: 'Блог', route: 'Seo.Blog' },
          { title: 'MetaPages', route: 'Seo.MetaPages' },
          { title: 'FAQ', route: 'Seo.Faq' },
          { title: 'FAQ группы', route: 'Seo.FaqGroups' },
          { title: 'Баннеры для блога', route: 'Seo.Banners' },
          { title: 'Категории блога', route: 'Seo.Categories' },
        ],
      },
      {
        action: 'moving',
        title: 'Девелопмент',
        routeGroup: 'Development',
        items: [
          { title: 'Менеджеры', route: 'Development.Managers' },
          { title: 'Города', route: 'Development.Cities' }
        ],
      },
      {
        action: 'person',
        title: 'Клиенты',
        routeGroup: 'Manager',
        route: 'Manager.Clients',
      },
      {
        action: 'assignment',
        title: 'Запись клиентов',
        routeGroup: 'Schedule',
        route: 'Schedule.ScheduleAssign',
      },
      {
        action: 'schedule',
        title: 'Расписание осмотров',
        routeGroup: 'Schedule',
        route: 'Schedule.ScheduleCreate',
      },
      {
        action: 'list',
        title: 'Просмотр записей на осмотр',
        routeGroup: 'ObjectManager',
        route: 'ObjectManager.AssignedList',
      },
    ],
  }),

  mounted() {
    this.drawer = this.$vuetify.breakpoint.xsAndUp
    this.activateMenu()
  },

  methods: {
    navigate({ route }) {
      if (route) {
        this.$router.push({ name: route }, () => {})
      }
    },

    openSearch() {
      this.searchOpened = true
    },

    closeSearch() {
      this.searchOpened = false
    },

    activateMenu() {
      let { name } = this.$router.currentRoute
      for (let x of this.menu) {
        if (void 0 === x.items) return
        x.active = x.items.some((x) => name.startsWith(x.route))
      }
    },

    ...mapActions('auth', ['logout']),
  },

  computed: {
    userMenu() {
      return this.menu.filter((menu) => {
        let route = this.$router.options.routes.find(
          (route) => route.name === menu.routeGroup
        )
        return route && this.$user.hasAccess(route)
      })
    },

    wide() {
      return this.$route.meta.wide
    },

    user() {
      return this.$user.get()
    },

    ...mapState('app', ['requests']),
  },
}
</script>

<style scoped>
.main-view {
  max-width: 1500px;
}
.main-view.wide {
  max-width: 100%;
}
.app >>> .v-navigation-drawer {
  margin-top: 64px !important;
}
.search {
  left: 325px;
  position: absolute;
}
.toolbar {
  z-index: 10;
}
.toolbar >>> .v-toolbar__content {
  padding-left: 16px;
  padding-right: 16px;
}
.progress {
  top: 0;
  right: 0;
  left: 0;
  position: absolute;
  z-index: 100500;
}
.progress >>> .v-progress-linear {
  margin: 0;
}
</style>
